<template>
  <svg
    class="DNA-values"
    viewBox="0 0 687.26 1098.06">
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="671.55"
        y1="772.35"
        x2="270.05"
        y2="123.85"
        gradientTransform="translate(0 1100) scale(1 -1)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#382c75" />
        <stop
          offset=".5"
          stop-color="#99b4ff" />
        <stop
          offset="1"
          stop-color="#382c75" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="447.89"
        y1="978.02"
        x2="30.89"
        y2="364.02"
        gradientTransform="translate(0 1100) scale(1 -1)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#382c75" />
        <stop
          offset=".51"
          stop-color="#99b4ff" />
        <stop
          offset="1"
          stop-color="#382c75" />
      </linearGradient>
    </defs>
    <g
      id="Layer_1"
      data-name="Layer 1">
      <path
        class="helix left-helix"
        d="M380.85,0c5.09,32.62,3.01,60.84-8.79,93.45C324.17,226.46,7.04,326.16.1,563.95c-4.4,158.22,141.33,272.72,157.53,278.04-28.45-41.87-59.45-101.09-74.48-167.7-8.1-35.39-11.8-73.79-8.56-110.34,16.89-191.3,363.4-287.06,364.32-436.03.46-61.99-58.06-127.92-58.06-127.92Z"
        style="fill: url(#linear-gradient-2); stroke-width: 0px" />
      <path
        class="helix right-helix"
        d="M248.34,970.37c0-150.59,347.21-249.59,364.32-436.03,4.16-44.41-2.54-89.06-15.27-133.24-16.19-55.75-43.49-109.18-67.78-144.8,16.19,5.32,162.15,119.82,157.53,278.04-6.71,237.79-323.84,337.49-371.96,470.27-11.8,32.61-13.88,60.83-8.79,93.45,0,0-58.06-65.92-58.06-127.92v.23Z"
        style="fill: url(#linear-gradient); stroke-width: 0px" />
    </g>
    <g
      id="Layer_5"
      data-name="Layer 5"
      class="cursor-pointer pill origin-center hover:scale-[1.02]"
      @click="setActiveDNAItem(3)">
      <path
        d="M143,675.03h269c17.67,0,32,14.33,32,32h0c0,17.67-14.33,32-32,32H143c-17.67,0-32-14.33-32-32h0c0-17.67,14.33-32,32-32Z"
        style="fill: rgba(255, 109, 0, 0.2); stroke-width: 0px" />
      <text
        transform="translate(186.2 716.98)"
        style="fill: #000; font-family: ArialMT, Arial; font-size: 30px">
        <tspan
          x="0"
          y="0">
          {{ orange }}
        </tspan>
      </text>
      <g>
        <image
          width="54"
          height="54"
          transform="translate(120.77 680.31)"
          xlink:href="@/assets/img/orange-orb.png" />
        <g>
          <line
            x1="147.77"
            y1="698"
            x2="147.77"
            y2="715.27"
            style="fill: none; stroke: #fff; stroke-width: 2px" />
          <path
            d="M139,706.64h17.27"
            style="fill: none; stroke: #fff; stroke-width: 2px" />
        </g>
      </g>
    </g>
    <g
      id="Layer_4"
      data-name="Layer 4"
      class="cursor-pointer pill origin-center hover:scale-[1.02]"
      @click="setActiveDNAItem(2)">
      <path
        d="M184,579.03h299c17.67,0,32,14.33,32,32h0c0,17.67-14.33,32-32,32H184c-17.67,0-32-14.33-32-32h0c0-17.67,14.33-32,32-32Z"
        style="fill: rgba(153, 180, 255, 0.2); stroke-width: 0px" />
      <g>
        <image
          width="54"
          height="54"
          transform="translate(450 584.66)"
          xlink:href="@/assets/img/lilac-orb.png" />
        <g>
          <line
            x1="476.77"
            y1="602"
            x2="476.77"
            y2="619.27"
            style="fill: none; stroke: #fff; stroke-width: 2px" />
          <path
            d="M468,610.64h17.27"
            style="fill: none; stroke: #fff; stroke-width: 2px" />
        </g>
      </g>
      <text
        transform="translate(180.57 621.29)"
        style="fill: #000; font-family: ArialMT, Arial; font-size: 30px">
        <tspan
          x="0"
          y="0">
          {{ lilac }}
        </tspan>
      </text>
    </g>
    <g
      id="Layer_3"
      data-name="Layer 3"
      class="cursor-pointer pill origin-center hover:scale-[1.02]"
      @click="setActiveDNAItem(1)">
      <path
        d="M148,483.03h404c17.67,0,32,14.33,32,32h0c0,17.67-14.33,32-32,32H148c-17.67,0-32-14.33-32-32h0c0-17.67,14.33-32,32-32Z"
        style="fill: rgba(111, 207, 215, 0.2); stroke-width: 0px" />
      <text
        transform="translate(200.61 525.6)"
        style="fill: #000; font-family: ArialMT, Arial; font-size: 30px">
        <tspan
          x="0"
          y="0">
          {{ cyan }}
        </tspan>
      </text>
      <g>
        <image
          width="54"
          height="54"
          transform="translate(126 488.53)"
          xlink:href="@/assets/img/cyan-orb.png" />
        <g>
          <line
            x1="152.77"
            y1="506"
            x2="152.77"
            y2="523.27"
            style="fill: none; stroke: #fff; stroke-width: 2px" />
          <path
            d="M144,514.64h17.27"
            style="fill: none; stroke: #fff; stroke-width: 2px" />
        </g>
      </g>
    </g>
    <g
      id="Layer_2"
      data-name="Layer 2"
      class="cursor-pointer pill origin-center hover:scale-[1.02]"
      @click="setActiveDNAItem(0)">
      <path
        d="M239,387.03h304c17.67,0,32,14.33,32,32h0c0,17.67-14.33,32-32,32H239c-17.67,0-32-14.33-32-32h0c0-17.67,14.33-32,32-32Z"
        style="fill: rgba(56, 44, 117, 0.1); stroke-width: 0px" />
      <g>
        <image
          width="54"
          height="54"
          transform="translate(505 392.5)"
          xlink:href="@/assets/img/purple-orb.png" />
        <line
          x1="531.77"
          y1="410"
          x2="531.77"
          y2="427.27"
          style="fill: none; stroke: #fff; stroke-width: 2px" />
        <path
          d="M523,418.64h17.27"
          style="fill: none; stroke: #fff; stroke-width: 2px" />
      </g>
      <text
        transform="translate(236.65 429.69)"
        style="fill: #000; font-family: ArialMT, Arial; font-size: 30px">
        <tspan
          x="0"
          y="0">
          {{ purple }}
        </tspan>
      </text>
    </g>
  </svg>
</template>
<script setup>
import useActiveDNAItem from '@/composables/useActiveDNAItem'
import gsap from 'gsap'
import scrollTrigger from 'gsap/ScrollTrigger'
import { onMounted } from 'vue'

gsap.registerPlugin(scrollTrigger)

defineProps(['purple', 'orange', 'cyan', 'lilac'])
const { setActiveDNAItem } = useActiveDNAItem()

const initialAnimation = () => {
  gsap.fromTo(
    '.helix',
    {
      opacity: 0,
      y: -10,
    },
    {
      opacity: 1,
      y: 0,
      duration: 1,
      stagger: 0.6,
      scrollTrigger: {
        trigger: '.DNA-values',
        start: 'top 80%',
      },
    }
  )
  gsap.fromTo(
    '.DNA-values .pill',
    {
      opacity: 0,
      y: -50,
    },
    {
      opacity: 1,
      y: 0,
      duration: 1,
      delay: 0.5,
      stagger: 0.2,
      ease: 'ease-in-out',
      scrollTrigger: {
        trigger: '.DNA-values',
        start: 'top 80%',
      },
    }
  )
}

onMounted(() => {
  initialAnimation()
})
</script>
<style lang="scss">
.DNA-values {
  .pill {
    transition: 0.1s transform ease-in-out;
  }
}
</style>
